import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import Button from '@src/components/button';
import { PAGE_ENUM, LEVEL_BLOCK } from './config';
import Block from './components/block';
import SevenSectionStore from './store';
import locales from './locales';
import { getAirmenInfo } from './utils';

const styles = {};
Object.entries(require('./index.less')).forEach(([key, value]) => {
  if (styles[key]) {
    styles[key] += ' ' + value;
  } else {
    styles[key] = value;
  }
});
Object.entries(require('./locales.less')).forEach(([key, value]) => {
  if (styles[key]) {
    styles[key] += ' ' + value;
  } else {
    styles[key] = value;
  }
});
// console.log(styles);

const SevenSection = ({ store }) => {
  store.use();

  // 渲染机兵等级
  const renderLevelPage = ({ isShow }) => {
    return (
      <section className={cx(styles.levelPage, isShow && styles.showPage)}>
        <Block
          whichActive={store.whichActive?.position}
          openEntryAnimation={isShow}
          config={LEVEL_BLOCK}
          enableGlitch={false}
          className={styles.block}
          onClick={cfg => store.onTogglePage(PAGE_ENUM.MECHA_TYPE, cfg.level)}
          onHover={store.onBlockHover}
        />
        <div className={styles.typeName}>{store.whichActive?.name}</div>
        <div className={styles.stage} />
        <Button className={styles.btnViewAll} data-name="查看全部机体谱系图" onClick={() => store.onViewAllPedigreeChart()} />
      </section>
    );
  };

  // 渲染机兵信息
  const renderMechaInfo = ({ info, isNext, isActive, isHidden, ref }) => {
    return (
      <section ref={ref} className={cx(styles.mechaInfo, isActive && styles.isActive, isHidden && styles.isHidden)}>
        {isNext ? (
          <React.Fragment>
            <div className={cx(styles.mecha)}>
              <img key={info?.id} src={info?.mecha} alt={info?.name} />
            </div>
            {/* <div className={cx(styles.mecha)} style={{ '--mecha': `url(${info?.mecha})` }}>
              <div className={styles.mechaSplit} style={{ backgroundImage: `url(${info?.mecha})` }} />
              <div className={styles.mechaSplit} style={{ backgroundImage: `url(${info?.mecha})` }} />
              <div className={styles.mechaSplit} style={{ backgroundImage: `url(${info?.mecha})` }} />
              <div className={styles.mechaSplit} style={{ backgroundImage: `url(${info?.mecha})` }} />
            </div> */}
            <div className={styles.mechaText} data-name="机兵信息展示">
              <div className={styles.threatLevel}>{`[ ${info?.threatLevel} ]`}</div>
              <div
                className={cx(
                  styles.mechaName,
                  // 处理德语某些机兵名称折行格式问题
                  ['qingjian-tk-a'].includes(info?.id) && styles.wrap_format_lang_de_qingjiantka
                )}
                data-name="机甲名称"
              >
                <span>{info?.name}</span>
              </div>
              {/* {store.level === MECHA_LEVEL.PAWN && <div className={styles.type}>{info?.type}</div>} */}
              <div className={styles.number}>
                {info?.id === 'kangsitanding' ? locales.shipType : locales.modelNumber}&nbsp;:&nbsp;
                <span>{info?.number}</span>
              </div>
              <div className={styles.attribute}>
                {info?.attributes.map((item, index) => {
                  return (
                    <div className={cx(styles.attributeItem)} key={index}>
                      <span className={styles.name}>{`[ ${item.name} ]`}</span>
                      <span className={styles.divider}>{'>'}</span>
                      <span className={styles.value}>{`${item.value}`}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className={cx(styles.mecha)}>{info?.mecha && <img key={info?.id} src={info?.mecha} alt={info?.name} />}</div>
        )}
      </section>
    );
  };

  // 预加载机兵立绘
  const preLoadMechaImg = () => {
    const mechaType = getAirmenInfo(store.level).mechaType || [];
    const mecha0 = mechaType.find(i => i.id === store.mechaIds[0]);
    const mecha1 = mechaType.find(i => i.id === store.mechaIds[1]);
    const mecha3 = mechaType.find(i => i.id === store.mechaIds[3]);
    const mecha4 = mechaType.find(i => i.id === store.mechaIds[4]);
    return (
      <div style={{ display: 'none' }}>
        <img src={mecha0.blockLeft} alt={mecha0.name} />
        <img src={mecha0.blockLeftHover} alt={mecha0.name} />
        <img src={mecha0.blockRight} alt={mecha0.name} />
        <img src={mecha0.blockRightHover} alt={mecha0.name} />
        <img src={mecha1.mecha} alt={mecha4.name} />
        <img src={mecha3.mecha} alt={mecha4.name} />
        <img src={mecha4.blockLeft} alt={mecha4.name} />
        <img src={mecha4.blockLeftHover} alt={mecha4.name} />
        <img src={mecha4.blockRight} alt={mecha4.name} />
        <img src={mecha4.blockRightHover} alt={mecha4.name} />
      </div>
    );
  };

  // 预加载按钮背景图片
  const preLoadButtonImg = () => {
    return (
      <div style={{ display: 'none' }}>
        <img src={require('./images/btn-view-all.png')} alt="" />
        <img src={require('./images/btn-view-all-hover.png')} alt="" />
        <img src={require('./images/btn-view-info.png')} alt="" />
        <img src={require('./images/btn-view-info-hover.png')} alt="" />
        <img src={require('./images/btn-back.png')} alt="" />
        <img src={require('./images/btn-prev.png')} alt="" />
        <img src={require('./images/btn-next.png')} alt="" />
      </div>
    );
  };

  // 渲染机兵类型
  const renderMechaTypePage = ({ isShow }) => {
    return (
      <section className={cx(styles.mechaTypePage, isShow && styles.showPage, styles[store.level])}>
        <Button buttonType="brightness" className={styles.btnBack} data-name="返回" onClick={() => store.onTogglePage(PAGE_ENUM.LEVEL)} />
        <Button buttonType="brightness" className={styles.btnPrev} data-name="上一个机兵" onClick={() => store.toggleMechaInfo('prev')} />
        <Button buttonType="brightness" className={styles.btnNext} data-name="下一个机兵" onClick={() => store.toggleMechaInfo('next')} />
        {isShow && preLoadMechaImg()}
        <Block
          ref={store.mechaTypeBlockRef}
          openEntryAnimation={isShow && store.openEntryAnimation}
          config={store.mechaTypeConfig}
          className={styles.block}
          enableGlitch={false}
          disabled={store.isMechaActive}
          onClick={item => {
            if (item.directive === 'left') {
              store.onPrevMecha();
            } else {
              store.onNextMecha();
            }
          }}
        />
        <div className={styles.stage} />
        {renderMechaInfo({ info: store.prevMechaInfo, isNext: false, isHidden: store.isHidden })}
        {renderMechaInfo({ info: store.mechaInfo, isNext: true, isActive: store.isMechaActive, ref: store.mechaInfoRef })}
        <Button className={styles.btnViewMechaInfo} data-name="解锁机体档案" onClick={() => store.onViewMechaInfo()} />
        <Button className={styles.btnViewAll} data-name="查看全部机体谱系图" onClick={() => store.onViewAllPedigreeChart()} />
      </section>
    );
  };

  // 渲染底部版权信息
  const renderFooter = () => {
    return (
      <React.Fragment>
        <Link
          className={cx(styles.footerBtn, store.isfooterOpen && styles.footerOut)}
          onClick={() => {
            store.onChangeFooterState(true);
          }}
        >
          {' '}
        </Link>
        <div className={cx(styles.footerBox, store.isfooterOpen ? styles.footerActive : styles.footerOut)}>
          <Footer className={styles.footer} store={store.footer} />
          {/* <Link
            className={styles.footer_close}
            onClick={() => {
              store.onChangeFooterState(false);
            }}
          /> */}
        </div>
      </React.Fragment>
    );
  };

  return (
    <div className={styles.sevenSectionRoot}>
      <div className={styles.container}>
        <div className={styles.hud} />
        <div className={styles.content}>
          {renderLevelPage({ isShow: store.page === PAGE_ENUM.LEVEL })}
          {renderMechaTypePage({ isShow: store.page === PAGE_ENUM.MECHA_TYPE })}
          {preLoadButtonImg()}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(SevenSection, SevenSectionStore);
